import styled from '@emotion/styled'
import { Jumbotron } from 'react-bootstrap'
import RemServImage from 'RemServ/images/banner.jpg'
import MaxxiaImage from 'Maxxia/images/banner1.jpg'
import MaxxiaImage2 from 'Maxxia/images/banner2.jpg'
import { PrimaryButton } from '@mmsg/louie'

interface IInputProps {
  maxxiaImageName?: string
}

export const BannerContentParentDiv = styled(Jumbotron)<IInputProps>`
  label: BannerContentParentDiv;

  background-color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.primary
      : props.theme.backgrounds.backGround2}
  margin: -122px auto 0 auto;
  width: 94%;
  min-height: 100px;
  box-shadow: 0 2px 16px 0 rgba(0; 0; 0; 0.16);
  padding: 0;
  max-width: 1046px;
  border-radius: 5px;
  display: table;
  position: relative;
  align-content: left;
  z-index: 90;
`
export const WhiteHeading = styled('h2')`
  label: WhiteHeading;
  margin-top: 80px;
  font-size: 20px;
  color: ${(props) => props.theme.colors.white} !important;
`
export const BannerTextSection = styled.div`
  label: BannerTextSection;
  color: ${(props) => props.theme.colors.bannerSectionContentColor};
`
export const BannerContent = styled.div`
  label: BannerContent;
  line-height: 32px;
  margin-right: 32px;
  @media (max-width: 719px) {
    margin-right: 0px;
  }
`
export const BannerButtonSection = styled.div`
  label: BannerButtonSection;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  & button {
    width: 100%;
  }
  & a {
    width: 100%;
  }
  margin-top: -18px;
  @media (max-width: 719px) {
    margin-top: 0px;
  }
`
export const BannerTitle = styled.div`
  label: BannerTitle;
  font-weight: bold;
`

export const BannerConstChildDiv = styled.div`
  label: BannerConstChildDiv;
  background-image: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? `linear-gradient(270deg, rgba(215,94,39,0.5), rgba(209,66,0,0.5) 50%), url('/images/banner-brand.jpg')`
      : ''};
  padding: 37px 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  overflow: hidden !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
  @media (max-width: 719px) {
    flex-direction: column;
  }
`
export const BannerContentBlock = styled('div')`
  label: BannerContentBlock;
  display: flex;
  flex-direction: column;
  align-items: center;
  > div:first-child {
    width: 100%;
  }
  >div: last-child {
    top: -90px;
  }
`

export const ImageDiv = styled.div<IInputProps>`
  label: ImageDiv;
  background-image: url(${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.maxxiaImageName === 'Banner1'
        ? MaxxiaImage
        : MaxxiaImage2
      : RemServImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
  padding: 37px;
  display: flex;
  justify-content: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'center' : 'left'};
  min-height: 450px;
  @media (max-width: 719px) {
    min-height: 250px;
  }
`

export const ImageHeading = styled.h1`
  label: ImageHeading;
  font-size: ${(props) =>
    props.theme.brand === 'Maxxia' ? '56px !important' : '48px !important'};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 600)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'center' : 'left'};
  align-items: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'center' : 'left'};
  color: #fff !important;
  margin: -122px auto 0 auto !important;
  width: 94%;
  max-width: 1046px;
  @media (max-width: 719px) {
    font-size: ${(props) =>
      props.theme.brand === 'Maxxia' ? '33px !important' : '28px !important'};
  }
`

export const StyledPrimaryButton = styled(PrimaryButton)`
  label: StyledPrimaryButton;
  border: ${(props) =>
    props.theme.brand === 'Maxxia' ? '1px solid #fff' : null};
`
